import { render } from "./logWarn.vue?vue&type=template&id=3855d0d4"
import script from "./logWarn.vue?vue&type=script&lang=js"
export * from "./logWarn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__